import { render, staticRenderFns } from "./CardBars.vue?vue&type=template&id=f247a498&"
import script from "./CardBars.vue?vue&type=script&lang=ts&"
export * from "./CardBars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports